function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "puzzle"
}, /*#__PURE__*/React.createElement("path", {
  d: "m18.8 12.53c.294.061.601-.015.832-.205.233-.189.368-.473.368-.774v-3.551c0-1.103-.897-2-2-2h-2.536c.023-.165.036-.332.036-.5 0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5c0 .168.013.335.036.5h-2.536c-1.103 0-2 .897-2 2v11c0 1.654 1.346 3 3 3h11c1.103 0 2-.897 2-2v-3.551c0-.301-.135-.585-.368-.774-.231-.19-.538-.268-.832-.205-.922.187-1.8-.543-1.8-1.47s.878-1.664 1.8-1.47zm-.801 4.934-.002 2.536h-10.997c-.552 0-1-.448-1-1v-11h4.012c.379 0 .727-.215.896-.555.169-.339.131-.745-.098-1.048-.142-.187-.31-.495-.31-.897 0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5c0 .402-.168.71-.31.897-.229.303-.267.709-.098 1.048.17.34.517.555.896.555h4.012v2.535c-1.694.244-3 1.705-3 3.465s1.306 3.221 2.999 3.464z"
}));

var Svg095Puzzle = function Svg095Puzzle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg095Puzzle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/095-puzzle.9e47feea.svg";
export { ForwardRef as ReactComponent };